// extracted by mini-css-extract-plugin
module.exports = {"editor":"Editor_editor__336cL"};